import { SvgIcon, SvgIconProps } from "@mui/material";

export function CarIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props}>
      <path d="M18.9,5 C18.7,4.4 18.1,4 17.5,4 L6.5,4 C5.8,4 5.3,4.4 5.1,5 L3,11 L3,19 C3,19.5 3.5,20 4,20 L5,20 C5.6,20 6,19.5 6,19 L6,18 L18,18 L18,19 C18,19.5 18.5,20 19,20 L20,20 C20.5,20 21,19.5 21,19 L21,11 L18.9,5 M6.8,6 L17.1,6 L18.2,9 L5.8,9 L6.8,6 M19,16 L5,16 L5,11 L19,11 L19,16 M7.5,12 C8.3,12 9,12.7 9,13.5 C9,14.3 8.3,15 7.5,15 C6.7,15 6,14.3 6,13.5 C6,12.7 6.7,12 7.5,12 M16.5,12 C17.3,12 18,12.7 18,13.5 C18,14.3 17.3,15 16.5,15 C15.7,15 15,14.3 15,13.5 C15,12.7 15.7,12 16.5,12 Z" />
    </SvgIcon>
  );
}
